import WebRTCAdaptor from '../../utils/webRTC'

export default class Webrtc {
  constructor(streamId, videoElementId, onError) {
    this.streamId = streamId
    this.videoElementId = videoElementId
    this.streamsFolder = 'streams'
    this.playOrder = ['webrtc', 'hls']
    this.name = ''
    this.token = ''
    this.onError = onError
    this.webRTCAdaptor = null
    this.initalize()
  }

  initalize() {
    var pcConfig = null

    var sdpConstraints = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true
    }
    var mediaConstraints = {
      video: false,
      audio: false
    }

    var websocketURL = 'wss://live.event.gives:5443/WebRTCAppEE/websocket'

    //webRTCAdaptor is a global variable
    const callbackHelper = (info, description) => {
      if (info === 'initialized') {
        this.webRTCAdaptor.getStreamInfo(this.streamId)
      } else if (info === 'streamInformation') {
        this.webRTCAdaptor.play(this.streamId, this.token)
      } else if (info === 'play_started') {
        document.getElementById(this.videoElementId).play()
      } else if (info === 'play_finished') {
        // console.log('play finished')
        this.onError({ info, description })
      } else if (info === 'closed') {
        console.log('websocket closed')
      }
    }

    const callbackErrorHelper = error => {
      console.log('error callback: ', error)
      if (error === 'no_stream_exist') {
        this.onError({ error })
      }
    }

    this.webRTCAdaptor = new WebRTCAdaptor({
      websocket_url: websocketURL,
      mediaConstraints: mediaConstraints,
      peerconnection_config: pcConfig,
      sdp_constraints: sdpConstraints,
      remoteVideoId: this.videoElementId,
      isPlayMode: true,
      debug: true,
      callback: callbackHelper.bind(this),
      callbackError: callbackErrorHelper.bind(this)
    })
  }

  kill() {
    this.webRTCAdaptor.stop()
    this.webRTCAdaptor.closeWebSocket()
  }
}



// WEBPACK FOOTER //
// ./src/components/LiveVideo/webrtc.js